import React from "react";
import { useTranslation } from "react-i18next";
import Container from "react-bootstrap/Container";

import { Title } from "./common/Title";

import styles from "../assets/styles/protocols.module.scss";

import adse from "../assets/images/protocols/adse.svg";
import sams from "../assets/images/protocols/sams.png";
import samsquadros from "../assets/images/protocols/samsquadros.png";
import maxicare from "../assets/images/protocols/maxicare.png";
import medicare from "../assets/images/protocols/medicare.svg";

export function Protocols() {
  const { t, i18n } = useTranslation("protocols");

  return (
    <section id="protocols" className={styles.protocols}>
      <Container data-aos="fade-up">
        <Title title={t("title")} />
      </Container>
      <div className={`d-flex flex-column gap-1 align-items-center justify-content-center ${styles.protocolsMainContainer}`}>
        <div className={`d-grid justify-content-center px-5 pt-5 pb-3 gap-5 ${styles.protocolsContainer}`}>
          <img src={samsquadros} alt="SAMS Quadros" />
          <img src={medicare} alt="Medicare" />
          <img src={sams} alt="SAMS" />
          <img src={maxicare} alt="Maxicare" />
          <div className="d-flex flex-column gap-1 align-items-center justify-content-center text-center">
            <img src={adse} alt="Adse" />
            <span>{t("adseExclusive")}</span>
          </div>
        </div>
        <div className="fs-3 m-3 text-center text-uppercase"><span>{t("dentalChecks")}</span></div>
      </div>
      

    </section>
  );
}
